export var ToolSize;
(function (ToolSize) {
    ToolSize["Regular"] = "regular";
    ToolSize["Compact"] = "compact";
})(ToolSize || (ToolSize = {}));
export var LocaleImageKind;
(function (LocaleImageKind) {
    LocaleImageKind["Single"] = "single";
    LocaleImageKind["Multi"] = "multi";
})(LocaleImageKind || (LocaleImageKind = {}));
export var ToolLayoutKind;
(function (ToolLayoutKind) {
    ToolLayoutKind["Bar"] = "bar";
    ToolLayoutKind["Circular"] = "circular";
    ToolLayoutKind["CustomImage"] = "custom-image";
    ToolLayoutKind["Fullscreen"] = "full-screen";
    ToolLayoutKind["FullscreenMini"] = "full-screen-mini";
    ToolLayoutKind["LowerNotification"] = "lower-notification";
    ToolLayoutKind["NotificationTab"] = "notification-tab";
    ToolLayoutKind["Sidebar"] = "sidebar";
    ToolLayoutKind["SideGradient"] = "side-gradient";
    ToolLayoutKind["SlideIn"] = "slide-in";
    ToolLayoutKind["Square"] = "square";
    ToolLayoutKind["SquareImage"] = "square-image";
    ToolLayoutKind["Sticky"] = "sticky";
    ToolLayoutKind["StickyImage"] = "sticky-image";
})(ToolLayoutKind || (ToolLayoutKind = {}));
export var ToolContentAlignment;
(function (ToolContentAlignment) {
    ToolContentAlignment["Left"] = "left";
    ToolContentAlignment["Center"] = "center";
    ToolContentAlignment["Right"] = "right";
})(ToolContentAlignment || (ToolContentAlignment = {}));
//# sourceMappingURL=layout.types.js.map